import { Box, InputLabel } from '@mui/material';
import React, { forwardRef, useEffect, useState } from 'react';

import { dayjs, getDateIsoString } from '../../utils/date';
import DatePicker from './DatePicker';
import { IDatePickerProps, IDateRangePickerProps } from './DatePicker.types';

const DateRangePicker = forwardRef(function DateRangePickerRef(
  {
    defaultValue = [new Date()?.toISOString(), new Date()?.toISOString()],
    value,
    onChange,
    maximumDate,
    minimumDate,
    minDateRange = 6,
    ...props
  }: IDateRangePickerProps,
  ref?: React.Ref<HTMLDivElement> | null
) {
  const [startDate, setStartDate] = useState<IDatePickerProps['value']>(
    defaultValue?.[0]
  );
  const [endDate, setEndDate] = useState<IDatePickerProps['value']>(
    defaultValue?.[1]
  );

  const dateChange1: IDatePickerProps['onChange'] = (d) => {
    setStartDate(d);
    // onChange?.(dateOrdering([d as string, endDate as string]));
    onChange?.([d as string, endDate as string]);
  };
  const dateChange2: IDatePickerProps['onChange'] = (d) => {
    setEndDate(d);
    // onChange?.(dateOrdering([d as string, startDate as string]));
    onChange?.([startDate as string, d as string]);
  };
  useEffect(() => {
    if (Array.isArray(value)) {
      if (value.every((d) => d)) {
        // const [date1, date2] = dateOrdering([
        //   getDateIsoString(value?.[0] as string),
        //   getDateIsoString(value?.[1] as string),
        // ]);
        const [date1, date2] = [
          getDateIsoString(value?.[0] as string),
          getDateIsoString(value?.[1] as string),
        ];
        setStartDate(date1);
        setEndDate(date2);
      }
    }
  }, [value]);

  return (
    <Box sx={{ display: 'flex', flexFlow: 'row', gap: 2 }}>
      <Box>
        <InputLabel>From</InputLabel>
        <DatePicker
          minDate={minimumDate && dayjs(minimumDate)}
          maxDate={maximumDate && dayjs(maximumDate)}
          // maxDate={
          //   maximumDate &&
          //   dayjs(maximumDate).set(
          //     'date',
          //     dayjs(maximumDate).get('date') - minDateRange
          //   )
          // }
          value={startDate ?? null}
          onChange={dateChange1}
        />
      </Box>
      <Box>
        <InputLabel>To</InputLabel>
        <DatePicker
          ref={ref}
          minDate={minimumDate && dayjs(minimumDate)}
          // minDate={
          //   startDate &&
          //   dayjs(startDate).set(
          //     'date',
          //     dayjs(startDate).get('date') + minDateRange
          //   )
          // }
          value={endDate ?? null}
          onChange={dateChange2}
          maxDate={maximumDate && dayjs(maximumDate)}
          {...props}
        />
      </Box>
    </Box>
  );
});
export default DateRangePicker;
